import { graphql } from 'msw';
import {
  FetchPurchaseOrdersQuery,
  FetchPurchaseOrdersQueryVariables,
  CapaQuotationRfqPurchaseOrder,
  CapaErrorCode,
  CapaPurchaseOrderStatus,
  CapaQuotationUserStatus,
  CapaQuotationPartnerStatus,
  CapaPaymentMethodType,
  CapapgProviders
} from '@generated/graphql';
import { v4 } from 'uuid';

const fetchPurchaseOrders = graphql.query<
  FetchPurchaseOrdersQuery,
  FetchPurchaseOrdersQueryVariables
>('fetchPurchaseOrders', (req, res, context) => {
  const { rfqId, quotationPartnerId } = req?.variables?.input ?? {
    rfqId: v4(),
    quotationPartnerId: v4()
  };
  const chatRoomId = v4();
  const purchaseOrderId = v4();
  const quotationId = v4();
  const quotationUserId = v4();
  const quotationPartnerUserId = v4();

  return res(
    context.data({
      fetchPurchaseOrders: {
        result: CapaErrorCode.Success,
        data: mockPurchaseOrders({
          rfqId,
          quotationPartnerId,
          chatRoomId,
          purchaseOrderId,
          quotationId,
          quotationUserId,
          quotationPartnerUserId,
          status: CapaPurchaseOrderStatus.Shipping
        }),
        errorMessage: null
      },
      __typename: 'Query'
    })
  );
});

export default fetchPurchaseOrders;

interface GenerateMockPurchaseOrdersArgs {
  purchaseOrderId: string;
  rfqId: string;
  quotationPartnerId: string;
  chatRoomId: string;
  status: CapaPurchaseOrderStatus;
  quotationId: string;
  quotationUserId: string;
  quotationPartnerUserId: string;
}

const mockPurchaseOrders: (
  args: GenerateMockPurchaseOrdersArgs
) => CapaQuotationRfqPurchaseOrder[] = ({
  purchaseOrderId,
  rfqId,
  quotationPartnerId,
  chatRoomId,
  status,
  quotationId,
  quotationUserId,
  quotationPartnerUserId
}) => [
  {
    __typename: 'CAPAQuotationRfqPurchaseOrder',
    id: purchaseOrderId,
    rfqId: rfqId,
    status: status,
    chatRoomId,
    createdAt: new Date().toISOString(),
    deliveryCost: 5000,
    isConfirmed: false,
    isRejected: false,
    items: [
      {
        cost: 5000,
        quantity: 10,
        fileName: '테스트 아이템 1',
        __typename: 'CAPAQuotationDetailedQuotationItem',
        etc: null,
        fileId: v4(),
        material: null
      },
      {
        cost: 10000,
        quantity: 5,
        fileName: '테스트 아이템 2',
        __typename: 'CAPAQuotationDetailedQuotationItem',
        etc: null,
        fileId: v4(),
        material: null
      }
    ],
    latest: true,
    maxDraftModificationCount: 5,
    paymentAmount: 21500,
    publish: {
      __typename: 'CAPAQuotationRfqPurchaseOrderPublish',
      companyRegistrationNumber: '1258212214',
      email: 'mocking@test.com',
      managerName: '테스트 고객',
      organizationName: '테스트 고객 회사명',
      phone: '00000000000',
      quotationUserStatus: CapaQuotationUserStatus.Registered
    },
    quotation: 15000,
    quotationCreatedAt: new Date().toISOString(),
    read: false,
    receiver: {
      __typename: 'CAPAQuotationRfqPurchaseOrderReceiver',
      quotationPartnerId: quotationPartnerId,
      quotationPartnerStatus: CapaQuotationPartnerStatus.Approved,
      address: '모킹시 테스트구 가짜3길 55',
      phone: '00000000000',
      companyRegistrationNumber: '00000000000',
      managerName: '테스트 파트너',
      email: 'mocking-partner@test.com',
      organizationName: '테스트 파트너 회사명'
    },
    shipAddress: '모킹시 테스트구  가짜3길 55',
    paymentCancelData: {
      __typename: 'FetchPurchaseOrderPaymentCancelData',
      amount: 21500,
      reason:
        'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate nesciunt minus, quaerat est eum repellat, illo qui quae reiciendis ad maiores nobis quo quod quasi. Quos eligendi pariatur minima ab! Lorem ipsum dolor sit amet consectetur adipisicing elit. At quaerat error velit laboriosam incidunt reiciendis corporis natus sit magni, quod eum libero consequuntur! Molestiae eos corrupti consectetur perspiciatis nihil id!'
    },
    shipDate: new Date().toISOString(),
    shipDetailAddress: '3층',
    adjustRequest: null,
    transfer: null,
    payments: null,
    pcb: null,
    pcbAssemblyItems: null,
    pcbFabricationItems: null,
    draftModificationTerms: null,
    inspectionPeriod: null,
    inspections: null,
    paymentDataList: [
      {
        __typename: 'FetchPurchaseOrderPaymentData',
        confirmedAt: new Date().toISOString(),
        quotationPartnerId,
        quotationUserId,
        quotationPartnerUserId,
        createdAt: new Date().toISOString(),
        paymentMethod: CapaPaymentMethodType.CreditCard,
        pgProvider: CapapgProviders.Nicepay,
        quotationId,
        rfqId,
        totalAmount: 21500,
        paidAt: new Date().toISOString(),
        purchaseOrderId,
        virtualAccount: null,
        cardInfo: {
          cardCode: '00',
          cardName: '테스트카드사',
          cardQuota: 0,
          cardType: 0,
          cardNumber: '1234567890123456',
          __typename: 'CAPAPaymentCardInfo'
        }
      }
    ],
    shippingDataList: [
      {
        id: v4(),
        isExtended: true,
        isRegistered: false,
        registerExpectedDate: '2022-12-25',
        extendedPurchaseConfirmDate: '2022-01-17',
        __typename: 'ShippingDataModel',
        extendReason:
          'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Voluptate nesciunt minus, quaerat est eum repellat, illo qui quae reiciendis ad maiores nobis quo quod quasi. Quos eligendi pariatur minima ab! Lorem ipsum dolor sit amet consectetur adipisicing elit. At quaerat error velit laboriosam incidunt reiciendis corporis natus sit magni, quod eum libero consequuntur! Molestiae eos corrupti consectetur perspiciatis nihil id!',
        invoiceNumber: null,
        shippingCompany: null
      }
    ]
  }
];
